import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Form, Field, FormSpy } from 'react-final-form';
import { components } from 'react-select';
import { useDebouncedCallback } from 'use-debounce';
import Input from '../Forms/input';
import Select from '../Forms/select';
import Message from '../Forms/message';
import TextArea from '../Forms/textarea';
import CheckBox from '../Forms/checkbox';
import AutoComplete from '../Forms/autocomplete';
import { InputWrapper } from '../Forms/common';
import Button from '../StoraEnsoComponents/Button';
import { useDroneDetailContext } from '../Contexts/DroneDetailContext';
import { getFeatureTypeIcon } from '../../utils/feature';
import { getPreviousFeatures } from '../../services/projectService';
import ChangedCoefficientDetector from './changedCoefficientDetector';
import ChangedFeatureDetector from './changedFeatureDetector';
import { getFloatValue } from '../../utils';

const CheckBoxWrapper = styled.div`
  margin-bottom: 14px;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  span {
    margin-left: 16px;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 8px;
  margin-bottom: 32px;
`;

const BtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${Button} {
    margin-bottom: 8px;
    width: 100%;
    /* max-width: 200px; */
  }
`;

const CustomSingleValue = props => {
    const { data: { label, featureType, profileType } } = props;

    return (
        <components.SingleValue {...props}>
            <OptionWrapper>
                {getFeatureTypeIcon({ featureType, profileType })}
                <span>ID: {label}</span>
            </OptionWrapper>
        </components.SingleValue>
    )
}

const CustomSelectOption = props => {
    const { data: { label, featureType, profileType } } = props;

    return (
        <components.Option {...props}>
            <OptionWrapper>
                {getFeatureTypeIcon({ featureType, profileType })}
                <span>ID: {label}</span>
            </OptionWrapper>
        </components.Option>
    )
}

function FeatureForm({ config, projectId, onFormSubmit, onApplyChanges, }) {
    const [configData, setConfigData] = useState(null)
    const [featureIdValues, setFeatureIdValues] = useState([]);
    const [previousProfiles, setPreviousProfiles] = useState([]);
    const { featuresData: features, selectedFeature, setSelectedFeature, setDeletedFeature, setUnsavedChanges } = useDroneDetailContext();
    const [formFeature, setFormFeature] = useState(null)

    const setDebouncedPrevProfiles = useDebouncedCallback((value) => {
        findPreviousFeature(value);
    }, 500);
    console.log(config);
    useEffect(() => {
        if (selectedFeature && config) {

            const selectedFeatureMap = {
                ...selectedFeature,
                properties: {
                    ...selectedFeature.properties,
                    featureId: {
                        label: selectedFeature.properties.id,
                        value: selectedFeature.properties.id,
                        featureType: selectedFeature.geometry.type,
                        profileType: selectedFeature.properties.profile_type,
                    },
                    logLength:selectedFeature.properties.log_length,
                    height:selectedFeature.properties.height_ground,
                    woodType: { label: selectedFeature.properties.type || config.definition[0].label, value: selectedFeature.properties.type || config.definition[0].label }
                }
            }

            setFormFeature(selectedFeatureMap);
            setConfigData(config?.definition.find(f => f.label === selectedFeatureMap.properties.woodType.label));
        }
    }, [selectedFeature, config]);

    useEffect(() => {
        setFeatureIdValues(
            features ? features.map(({ properties: { id, profile_type }, geometry: { type } }) => ({
                label: id,
                value: id,
                featureType: type,
                profileType: profile_type,
            })) : []
        );
    }, [features]);

    const findPreviousFeature = (name) => {
        if (name.trim().length >= 2) {
            console.log(name)
            getPreviousFeatures(projectId, name.trim())
                .then(data => {
                    setPreviousProfiles(data.map(d => ({
                        id: `${d.name}, ${d.coeficient}`,
                        label: `${d.name}, ${d.coeficient}`,
                        data: d
                    })))
                })
        }
    }

    const submitForm = (values) => {
        onFormSubmit({
            ...formFeature,
            properties: {
                ...formFeature.properties,
                type: values.woodType?.label,
                coefficient_def: values.coefficient_def,
                name: values.name || '',
                description: values.description || '',
                log_length: getFloatValue(values.logLength),
                coeficient: getFloatValue(values.coeficient),
                height_ground: getFloatValue(values.height),
            }
        });
    }

    const handleApplyChanges = (values) => {
        console.log(formFeature);
        onApplyChanges({
            ...formFeature,
            properties: {
                ...formFeature.properties,
                name: values.name || '',
                description: values.description || '',
                type: values.woodType?.label,
                coefficient_def: values.coefficient_def,
                log_length: getFloatValue(values.logLength),
                coeficient: getFloatValue(values.coeficient),
                height_ground: getFloatValue(values.height),
            }
        });
    }

    return (
        <Form
            onSubmit={submitForm}
            initialValues={formFeature?.properties}
            render={({ submitting, pristine, values, handleSubmit, hasValidationErrors, hasSubmitErrors, form: { change } }) => (
                <div id="featureForm">
                    <ChangedFeatureDetector />
                    <ChangedCoefficientDetector />
                    <Field name="featureId">
                        {({ input, meta }) => (
                            <InputWrapper >
                                <label>Feature</label>

                                <Select
                                    id="featureId"
                                    options={featureIdValues}
                                    customComponents={{ Option: CustomSelectOption, SingleValue: CustomSingleValue }}
                                    {...input}
                                    onChange={value => {
                                        console.log(value);
                                        console.log(features)
                                        input.onChange(value);
                                        setSelectedFeature(features.find(el => el.properties.id === value.value));
                                    }}
                                />
                                {
                                    meta.touched && meta.error && (
                                        <Message isError>{meta.error}</Message>
                                    )
                                }
                            </InputWrapper>
                        )}
                    </Field>
                    {formFeature?.geometry.type === 'Polygon' &&
                        <Field name="isBox" type="checkbox">
                            {({ input, meta }) => (
                                <CheckBoxWrapper>
                                    <CheckBox
                                        {...input}
                                        {...meta}
                                        id="isBox"
                                        label="Box"
                                    />
                                </CheckBoxWrapper>
                            )}
                        </Field>
                    }
                    <Field name="name" >
                        {({ input, meta }) => (
                            <InputWrapper>
                                <label>Name</label>
                                <AutoComplete
                                    id="name"
                                    items={previousProfiles}
                                    input={input}
                                    meta={meta}
                                    onChange={value => {
                                        setDebouncedPrevProfiles(value);
                                        input.onChange(value);
                                    }}
                                    onSelect={item => {
                                        change('description', item.data.description);
                                        change('logLength', item.data.log_length);
                                        change('coeficient', item.data.coeficient);
                                        change('height', item.data.height_ground);
                                        input.onChange(item.data.name)
                                    }}
                                />
                                {
                                    meta.touched && meta.error && (
                                        <Message isError>{meta.error}</Message>
                                    )
                                }
                            </InputWrapper>
                        )}
                    </Field>
                    <Field name="description">
                        {({ input, meta }) => (
                            <InputWrapper>
                                <label>Description</label>
                                <TextArea
                                    rows="3"
                                    {...input}
                                    {...meta}
                                    id="descriptionInput" />
                                {
                                    meta.touched && meta.error && (
                                        <Message isError>{meta.error}</Message>
                                    )
                                }
                            </InputWrapper>
                        )}
                    </Field>
                    <Grid>
                        <Field name="woodType" >
                            {({ input, meta }) => (
                                <InputWrapper>
                                    <label>Wood type</label>

                                    <Select
                                        id="woodType"

                                        options={config?.definition || []}
                                        getOptionLabel={(options) => options['label']}
                                        getOptionValue={(options) => options['label']}
                                        {...input}
                                        onChange={value => {
                                            change('coefficient_def', {});
                                            input.onChange({ "value": value.label, "label": value.label });
                                            setConfigData(config?.definition.find(f => f.label === value.label))
                                        }}
                                    />
                                    {
                                        meta.touched && meta.error && (
                                            <Message isError>{meta.error}</Message>
                                        )
                                    }
                                </InputWrapper>
                            )}
                        </Field>
                        {
                            configData?.values.map(c => (
                                <Field name={`coefficient_def.${c.label}`} key={c.label} value={c.values[0]}>
                                    {({ input, meta }) => (
                                        <InputWrapper>
                                            <label>{c.label}</label>
                                            <Select
                                                id={c.label}
                                                options={c.values}
                                                clearable={false}
                                                getOptionLabel={(options) => options['label']}
                                                getOptionValue={(options) => options['value']}

                                                {...input}
                                                onChange={value => {
                                                    input.onChange(value)
                                                    console.log(values.coefficient_def)
                                                }}
                                            />
                                            {
                                                meta.touched && meta.error && (
                                                    <Message isError>{meta.error}</Message>
                                                )
                                            }
                                        </InputWrapper>
                                    )}
                                </Field>
                            ))
                        }
                        {formFeature?.geometry.type !== 'Polygon' &&
                        <Field name="logLength">
                            {({ input, meta }) => (
                                <InputWrapper>
                                    <label>Log length</label>
                                    <Input id="logLengthInput" {...input} />
                                    {
                                        meta.touched && meta.error && (
                                            <Message isError>{meta.error}</Message>
                                        )
                                    }
                                </InputWrapper>
                            )}
                        </Field>}

                        <Field name="coeficient">
                            {({ input, meta }) => (
                                <InputWrapper>
                                    <label>Coeficient</label>
                                    <Input id="coeficientInput" {...input} />
                                    {
                                        meta.touched && meta.error && (
                                            <Message isError>{meta.error}</Message>
                                        )
                                    }
                                </InputWrapper>
                            )}
                        </Field>
                        <Field name="height">
                            {({ input, meta }) => (
                                <InputWrapper>
                                    <label>Height above ground (m)</label>
                                    <Input id="heightInput" {...input} />
                                    {
                                        meta.touched && meta.error && (
                                            <Message isError>{meta.error}</Message>
                                        )
                                    }
                                </InputWrapper>
                            )}
                        </Field>
                    </Grid>
                    <BtnWrapper>
                        <Button
                            size="sm"
                            kind="negative"
                            onClick={() => {
                                setUnsavedChanges(true);
                                setDeletedFeature(selectedFeature)
                            }}>
                            Delete
                        </Button>
                        <Button id="calculate" type="submit" onClick={handleSubmit}>
                            Calculate
                        </Button>
                        <Button
                            disabled={pristine}
                            onClick={() => {
                                setUnsavedChanges(true);
                                handleApplyChanges(values)
                            }}>
                            Apply
                        </Button>
                    </BtnWrapper>
                    {/* <FormSpy subscription={{ values: true, errors: true }}>
              {({ values, errors }) => (
                <pre>
                  {JSON.stringify(values, null, 2)}
                  {JSON.stringify(errors, null, 2)}
                </pre>
              )}
            </FormSpy> */}
                </div>
            )}
        />
    );
}
export default FeatureForm;